import React, { Fragment } from "react";
import { useTranslation }  from "react-i18next";

import { getResponsiveImage }             from "_common/utils";
import FetchMore                          from "_components/atoms/fetchMoreLoader";
import Icon                               from "_components/atoms/icon";
import Image                              from "_components/atoms/image";
import Loader                             from "_components/atoms/loader";
import Render                             from "_components/atoms/render";
import Tooltip                            from "_components/atoms/tooltip";
import Typography                         from "_components/atoms/typography";
import FanScoreCard, { CurrentScoreCard } from "_components/molecules/fanScoreCard";
import TopPointScoreCard                  from "_components/molecules/TopPointScoreCard";
import useStyles                          from "_styles/organisms/fanLeaderboard";

const component = props => {
	const {
		isFetching,
		isDepleted,
		data,
		broadcasterName,
		distributionStatus,
		currentUser,
		onRefresh,
		giveAwayCoins,
		isSessionEnded,
		userProfile = {},
		showCurrentUserScroreCard,
		loadMore
	} = props;

	const { classes } = useStyles ( { showCurrentUserScroreCard } );
	const { t }       = useTranslation ();

	let rankingData = data;

	let topThreeUsers = [];

	if ( distributionStatus ) {
		topThreeUsers = rankingData.slice ( 0, 3 );
		rankingData   = rankingData.slice ( 3 );
	}

	return (
		<div className = { classes.container }>
			<Render condition = { showCurrentUserScroreCard }>
				<div className = { classes.currentUserFanRank }>
					<CurrentScoreCard
						authorName         = { currentUser ? currentUser?.sportsFan?.name : userProfile?.name }
						authorProfileImage = { currentUser ? getResponsiveImage ( currentUser?.sportsFan?.photo ) : getResponsiveImage ( userProfile?.photo ) }
						fanRank            = { currentUser ? currentUser?.rank : "-" }
						isCurrentUser      = { true }
						points             = { currentUser ? currentUser?.score : 0 }
						profileHref        = { `/profile/${ userProfile?.id }` }
					/>
				</div>

			</Render>

			<div className = { classes.creatorCardContainer }>
				<div className = { classes.fanRankIcons }>

					<Tooltip
						title = "Refresh Fan Rank"
					>
						<div
							className = { classes.refreshButton }
							onClick   = { onRefresh }
						>
							<Icon
								className = { classes.svgIconRefresh }
								name      = "refresh"
							/>

							{/* <IconButton size = "large">

								{
									darkMode ?
										<RefreshFanRank className = { classes.svgIconRefreshDark } /> :
										<RefreshFanRank className = { classes.svgIconRefresh } />
								}
							</IconButton> */}
						</div>
					</Tooltip>
				</div>

				<Render condition = { !isSessionEnded }>
					<div className = { classes.creatorCard }>
						<Image
							lazy  = { false }
							src   = "/images/fanRankBanner.png"
							width = "100%"
						/>

						<div className = { classes.creatorCardRight }>

							<Typography
								className = { `${ classes.giveAwayText } colorWhite` }
								color     = "textSecondary"
								style     = { { textAlign: "center !important", fontSize: "11px" } }
								title     = { `Watch ${ broadcasterName }'s Stream For Longest & Win` }
								variant   = "body4"
							/>

							{" "}

							<div className = { classes.giveAwayStyles }>
								<Icon sameInBothTheme
									className = { classes.coinSvg }
									name      = "fanRankCoinInBanner"
								/>

								{" "}

								<span className = { classes.coinAmt }>
									{giveAwayCoins}

									{" "}
								</span>
							</div>
						</div>
					</div>
				</Render>

				<Render condition = { distributionStatus }>
					<div className = { classes.endedView }>
						{
							topThreeUsers.map ( item => (
								<TopPointScoreCard
									key                = { item.userId }
									authorName         = { item.sportsFan.name }
									authorProfileImage = { item.sportsFan.photo }
									coins              = { item.coins ? item.coins : 0 }
									fanRank            = { item.rank }
									points             = { item.score }
								/>
							) )
						}
					</div>
				</Render>

				<Render condition = { isFetching && !data?.length }>
					<Loader />
				</Render>

				<Render condition = { !isFetching && !data?.length }>
					<div className = { classes.emptyfanRank }>

						<Icon sameInBothTheme
							className = { classes.emptyfanRankIcon }
							name      = "emptyFanRank"
							size      = { 100 }

						>
						</Icon>

						<p className = { classes.emptyfanRankText }>
							{t ( "empty_fan_rank" )}
						</p>
					</div>

				</Render>

				<Render condition = { data?.length }>
					{
						rankingData.map ( item => {
							return (
								<Fragment key = { item.userId }>
									<FanScoreCard
										key                = { item.userId }
										authorName         = { item.sportsFan.name }
										authorProfileImage = { item.sportsFan.photo }
										coins              = { item.coins }
										fanRank            = { item.rank }
										isSessionEnded     = { isSessionEnded }
										points             = { item.score }
										profileHref        = { `/profile/${ item.userId }` }
									/>
								</Fragment>
							);
						} )
					}

					<FetchMore
						fetchMore  = { loadMore }
						isDepleted = { isDepleted }
						isLoading  = { isFetching }
					/>

				</Render>
			</div>
		</div>
	);
};

export default component;
